/**
 * Gestisce l'applicazione, il salvataggio e l'aggiornamento visivo del tema globale (Light/Dark/Default).
 * @param {string|null} [data_action=null] - L'azione scatenata dal selettore ("light", "dark", "default" o null all'avvio).
 */
export function setAndSaveGlobalTheme(data_action = null) {
  let themeToApply;
  let savedTheme = localStorage.getItem('theme');

  // 1. Gestione della scelta dell'utente (Click sul selettore)
  if (data_action) {
    if (data_action === 'default') {
      localStorage.removeItem('theme');
      savedTheme = null; // Resettiamo la variabile locale per il controllo successivo
    } else {
      localStorage.setItem('theme', data_action);
      savedTheme = data_action;
    }
  }

  // 2. Determinazione del tema effettivo da applicare a Bootstrap
  if (savedTheme) {
    // Se c'è un tema salvato ('light' o 'dark'), usiamo quello
    themeToApply = savedTheme;
  } else {
    // Se siamo in 'default' (savedTheme è null), interroghiamo il sistema operativo
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    themeToApply = systemPrefersDark ? 'dark' : 'light';
  }

  // 3. Applica il tema a Bootstrap (sul tag <html>)
  document.documentElement.setAttribute('data-bs-theme', themeToApply);

  // 4. Gestisci i file CSS condizionali (es. Flatpickr)
  const flatpickrDarkLink = document.getElementById('flatpickr-dark-theme');
  if (flatpickrDarkLink) {
    flatpickrDarkLink.disabled = (themeToApply === "light");
  }
}